<template>
    <div>
        <h4 class v-html="financingMentions.title" />
        <p class="mb-1" v-html="financingMentions.text" />
    </div>
</template>

<script>
export default {
    name: "FinancingMentions",
    props: {
        financingMentions: {
            type: Object,
            required: true
        }
    },
}
</script>
